import lazyLoadView from "./lazyload-view";
import routeError from "./route-error";
import store from '@store'
import { FAKE_BULLETINITEM, FAKE_EVENTITEM } from "../config/fake-news";

export default [
  // ===
  // 新訊
  // ===
  {
    path: '/product/brand/microsoft/solutionhub/news/:categoryAlias?',
    name: 'news-list',
    component: () => lazyLoadView(import('@views/News/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      title: '新訊／活動'
    },
  },
  {
    path: '/product/brand/microsoft/solutionhub/news/:categoryAlias/:alias',
    name: 'news-item',
    component: () => lazyLoadView(import('@views/News/Item')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const newItem = await store.dispatch('article/fetchItem',{
            contentType: routeTo.params.categoryAlias,
            alias: routeTo.params.alias
          })
          // let currentItem = {}
          // if(routeTo.params.seriesNum)  {
          //   const newItem = await store.dispatch('article/fetchItem',{
          //     contentType: 'resource',
          //     alias: routeTo.params.alias
          //   })
          //   currentItem = newItem.items
          // } else {
          //   currentItem = FAKE_BULLETINITEM
          // }
          routeTo.params.defaultValue = newItem.items;
          routeTo.params.breadcrumbLevel1Title = routeTo.params.categoryAlias === 'event'
          ? ' 活動'
          : '新訊'
          routeTo.params.breadcrumbTitle = newItem.items.title
          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      title: '新訊／活動-內容頁'
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue || {},
    })
  },
]